import React, { SyntheticEvent } from 'react';
import { DateTime } from 'luxon';
import Dropdown, { DropdownOption } from '../../components/Dropdown';
import Input, {
  FilterLabeledInputRowWrapper,
} from '../../components/forms/Input';
import MessageDisplay, {
  MessageTypes,
} from '../components/styledComponent/MessageDisplay';

interface InputFilterProps {
  id: string;
  label: string;
  filter: string | DateTime | null;
  keypressHandler: (event: SyntheticEvent<HTMLInputElement>) => void;
  error?: string;
  maxLength?: number;
  width?: string;
}

interface DropdownProps {
  id: string;
  label: string;
  filter: string | DateTime;
  dropdownOptions: DropdownOption<string>[];
  keypressHandler: (value: string | number | readonly string[] | undefined) => void;
  error: string;
}

export const TextInput = ({
  id,
  label,
  filter,
  keypressHandler,
  error,
  maxLength,
}: InputFilterProps) => {
  return (
    <>
      <FilterLabeledInputRowWrapper elementId={id} label={label}>
        <Input
          id={id}
          name={id}
          value={filter?.toString()}
          onChange={keypressHandler}
          autocomplete="off"
          error={!!error}
          maxLength={maxLength}
        />
        {error && (
          <MessageDisplay type={MessageTypes.ERROR}>{error}</MessageDisplay>
        )}
      </FilterLabeledInputRowWrapper>
    </>
  );
};

export const DateInput = ({
  id,
  label,
  filter,
  keypressHandler,
  error,
  width,
}: InputFilterProps) => {
  return (
    <>
      <FilterLabeledInputRowWrapper width={width} elementId={id} label={label}>
        <Input
          id={id}
          name={id}
          value={filter?.toString()}
          onChange={keypressHandler}
          autocomplete="off"
          error={!!error}
          type="date"
        />
        {error && (
          <MessageDisplay type={MessageTypes.ERROR}>{error}</MessageDisplay>
        )}
      </FilterLabeledInputRowWrapper>
    </>
  );
};

export const DropdownInput = ({
  id,
  label,
  filter,
  dropdownOptions,
  keypressHandler,
  error,
}: DropdownProps) => {
  return (
    <>
      <FilterLabeledInputRowWrapper elementId={id} label={label}>
        <Dropdown
          id={id}
          value={filter.toString()}
          options={dropdownOptions}
          onChange={keypressHandler}
          error={!!error}
        />
        {error && (
          <MessageDisplay type={MessageTypes.ERROR}>{error}</MessageDisplay>
        )}
      </FilterLabeledInputRowWrapper>
    </>
  );
};
